export default function ($http) {
    return function (vehicleId, keeperId, dontContact) {
        return $http.put(`api/vehicles/${ vehicleId }/keepers/${ keeperId }/${ dontContact }`);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/keepers/keeperContact.js